<template>
  <div>
    <h3 class="title" v-text="title"></h3>
    <div
      v-if="loading"
      :style="{ display: 'flex', justifyContent: 'center', alignItems: 'center' }"
    >
      <v-progress-circular :size="64" color="primary" indeterminate />
    </div>
    <ul v-else class="broadcast-list">
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.broadcast-list {
  li {
    + li {
      margin-top: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/ExecutiveBroadcast/List.vue